import Vue from "vue";
import ElementUI from "element-ui";
// import Antd from "ant-design-vue";
import Avue from "@smallwei/avue";
import "@smallwei/avue/lib/index.css";
import axios from "./axios";
import "element-ui/lib/theme-chalk/index.css";
import dataV from "@jiaminghi/data-view";
import router from "./router.js";
import App from "./App.vue";
import "./styles/common.scss";

import "./styles/font/font.css";
// import "./styles/main.less";
// import "./styles/main.scss";
import "@/utils/es6";
import "@/mock/";
//导入主题文件
import "@/theme/index.js";
// import "./styles/iconfons/iconfont.js";
Vue.config.productionTip = false;
window.axios = axios;
Vue.use(Avue, {
  size: "mini",
});
Vue.prototype.$website = window.$website;
Vue.use(ElementUI);
// Vue.use(Antd);
Vue.use(dataV);
new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");

// 全局获取url参数的方法
window.getQueryVariable = function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
};

const Parse = require("parse");
Parse.initialize("com.smartxdc.engineering_platform", "LKSoft@123");
Parse.serverURL = `http://${window.$website.parseUrl}/engineering_platform`;
window.$parse = Parse;
